import { focusVisible } from "@mittwald/flow-styles/dist/mixins/focusVisible";
import { color } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import { textColorMixin } from "../../../mixins/textColor";
import { Link } from "../../Link";
export const ItemLink = styled(Link) `
  cursor: not-allowed;

  && {
    color: ${color.font.text.default};
  }

  &:not(.hasAction) {
    color: ${color.font.text.disabled};
  }

  &.hasAction {
    cursor: pointer;

    &.active {
      color: ${color.font.link.default};
      ${textColorMixin};
    }
  }

  &:hover,
  &.hover {
    background-color: ${color.background.default};
  }

  &.active {
    font-weight: bold;
    background-color: ${color.background.selectableBox.default};
  }

  &.disabled {
    pointer-events: none;
    color: ${color.font.text.disabled};
  }

  ${focusVisible}
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSXRlbUxpbmsuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9JbmxpbmVOYXZpZ2F0aW9uL3N0eWxlZC9JdGVtTGluay50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsWUFBWSxFQUFFLE1BQU0sZ0RBQWdELENBQUM7QUFDOUUsT0FBTyxFQUFFLEtBQUssRUFBRSxNQUFNLGdEQUFnRCxDQUFDO0FBQ3ZFLE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFDO0FBQ3ZDLE9BQU8sRUFBRSxjQUFjLEVBQUUsTUFBTSwyQkFBMkIsQ0FBQztBQUMzRCxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0sWUFBWSxDQUFDO0FBRWxDLE1BQU0sQ0FBQyxNQUFNLFFBQVEsR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUE7Ozs7YUFJdkIsS0FBSyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsT0FBTzs7OzthQUl2QixLQUFLLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxRQUFROzs7Ozs7O2VBT3RCLEtBQUssQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLE9BQU87UUFDOUIsY0FBYzs7Ozs7O3dCQU1FLEtBQUssQ0FBQyxVQUFVLENBQUMsT0FBTzs7Ozs7d0JBS3hCLEtBQUssQ0FBQyxVQUFVLENBQUMsYUFBYSxDQUFDLE9BQU87Ozs7O2FBS2pELEtBQUssQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLFFBQVE7OztJQUdqQyxZQUFZO0NBQ2YsQ0FBQyJ9